import useMediaQuery from "@mui/material/useMediaQuery";

import { MOBILE_MEDIA_QUERY } from "../../constants/mediaQueries";

const OnDesktop = ({ children }) => {
    const isDesktop = useMediaQuery(MOBILE_MEDIA_QUERY);

    if (isDesktop) return children;
};

export default OnDesktop;
